import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, InputLabel } from '@material-ui/core';
import cx from 'classnames';
import { useTranslation } from 'utils/modifiedTranslation';
import useStyles from './styles';

const InputFieldContainer = (props) => {
  const {
    label, helperText, labelClassName, helperTextClassName, isRequired, children,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      {label.length > 0 && (
        <InputLabel className={cx(classes.inputLabel, labelClassName)}>
          {t(label)}
          {' '}
          {isRequired && <span className={classes.required}> (required)</span>}
        </InputLabel>
      )}
      {children}
      <FormHelperText className={cx(classes.helperText, helperTextClassName)}>{t(helperText)}</FormHelperText>
    </div>
  );
};

InputFieldContainer.propTypes = {
  /**
   * Label of the input.
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * String for displaying under the input
   */
  helperText: PropTypes.string,
  /**
   * Classname for the label
   */
  labelClassName: PropTypes.string,
  /**
   * Classname for the helper text
   */
  helperTextClassName: PropTypes.string,
  /**
   * Flag to make input required to be filled.
   */
  isRequired: PropTypes.bool,
  children: PropTypes.object,
};

InputFieldContainer.defaultProps = {
  label: '',
  helperText: '',
  labelClassName: '',
  isRequired: false,
  children: {},
};

export default InputFieldContainer;
